import { Link } from 'react-router-dom';
import { t, getal } from '../i18n.js';
import { MODULE_ICOON } from './iconen.jsx';

/**
 * Een tegel per module, in het overzicht (docs/besluiten/modules-per-klant.md): de stand, het aantal open alerts uit die
 * module (rood bij kritiek, oranje bij hoog of midden) en de weg naar de pagina van die module.
 *
 * modules: [{ id, label, aan, van }] (aan: bij hoeveel klanten, van: hoeveel klanten); alerts: de open alerts.
 *
 * `rij` (bovenaan het overzicht, Bernhard, 2026-10-26): alle modules naast elkaar, klein: icoon, aantal en de korte naam
 * (zonder wat tussen haakjes staat); de stand in de tooltip. Een module die nergens in gebruik is (`gebruikt`: aan én
 * ingericht) is grijs.
 */
export const modulePaginas = { basis: '/bronnen', vpn: '/vpn', firewall: '/alerts?module=firewall', kwetsbaar: '/alerts?module=kwetsbaar',
  scan: '/scans', umbrella: '/umbrella', secureendpoint: '/endpoints', identity: '/identity', duo: '/duo', mail: '/mail' };

export default function ModuleTegels({ modules, alerts, basis = '', naar = modulePaginas, metStand = true, rij = false }) {
  return (
    <div className={`modtegels${rij ? ' rij' : ''}`} style={rij ? { '--n': modules.length } : undefined}>
      {modules.map((m) => {
        const eigen = alerts.filter((a) => a.module?.id === m.id && a.status !== 'afgesloten' && !a.resolvedAt);
        const kritiek = eigen.some((a) => a.severity === 'critical');
        const klasse = kritiek ? 'crit' : eigen.length ? 'warn' : '';
        const stand = m.van === undefined ? (m.aan ? t('aan') : t('uit'))
          : m.aan === m.van ? t('aan bij alle klanten') : t('aan bij {n} van {m} klanten', { n: m.aan, m: m.van });
        if (rij) {
          return (
            <Link key={m.id} to={`${basis}${naar[m.id] ?? `/alerts?module=${m.id}`}`} className={`tile modtegel klein ${klasse} ${m.gebruikt === false || !m.aan ? 'uit' : ''}`}
              title={`${t(m.label)} · ${eigen.length === 1 ? t('1 open alert') : t('{n} open alerts', { n: getal(eigen.length) })} · ${stand}${m.aan && m.gebruikt === false ? ` · ${t('nog niet ingericht')}` : ''}`}>
              <div className="modkop"><span className="modicoon">{MODULE_ICOON[m.id]}</span><div className="n">{getal(eigen.length)}</div></div>
              <div className="t"><b>{t(m.label).replace(/\s*\(.*\)$/, '')}</b></div>
            </Link>
          );
        }
        return (
          <Link key={m.id} to={`${basis}${naar[m.id] ?? `/alerts?module=${m.id}`}`} className={`tile modtegel ${klasse} ${m.aan ? '' : 'uit'}`}>
            <div className="modkop"><span className="modicoon">{MODULE_ICOON[m.id]}</span><div className="n">{getal(eigen.length)}</div></div>
            <div className="t"><b>{t(m.label)}</b><br />
              {eigen.length === 1 ? t('1 open alert') : t('{n} open alerts', { n: getal(eigen.length) })}
              {metStand && <><br /><span className="muted">{stand}</span></>}</div>
          </Link>
        );
      })}
    </div>
  );
}
